import React from "react";

const SvgComponent = ({ ...props }) => {
  const { iconSize, iconColor, className } = props;
  return (
    <svg stroke={iconColor || 'currentColor'} fill="none" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round"  height={iconSize || '1em'} width={iconSize || '1em'} xmlns="http://www.w3.org/2000/svg"  className={className}>
      <polyline points="15 18 9 12 15 6"></polyline>
    </svg>
  );
};

export default SvgComponent;
